import type { LibItemSysIcon } from '@types';
import { cbIconList } from '../LibCBIconModal/cbIconList';
import {
  type LibItemCLayerIcon,
  cLayerIconAll,
} from '../LibCLayerIconModal/cLayerIconList';

type Group = {
  name: string;
  list: LibItemCLayerIcon[];
};

const imageList: Group = {
  name: '地产行业',
  list: [
    {
      url: '/hotspots/system/map/realestate/xiangshoushenghuo-1.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/xuequjujidi-1.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/pingzhizhuzhai-1.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/jijiangkaipan-1.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/fuhaojuji-1.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/chenshihouhuayuan-1.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/weilaizhongxin.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/dishoufu.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/huiqianqu.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/gaishan.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/gangxu.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/gangxuzizhu.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/gaoxiao.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/rexiao.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/chengaipianqu.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/fazhanxinqu.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/gaishanbaozhi.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/changqitouzi.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/jijiangqifei.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/chenxiangjiehebu.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/xiangshoushenghuo.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/xuequjujidi.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/chenshizhongxin.gif',
      frame: 1,
      isGif: true,
    },
    { url: '/hotspots/system/map/realestate/cbd.gif', frame: 1, isGif: true },
    {
      url: '/hotspots/system/map/realestate/yanglao.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/chaodi.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/huanjinghao.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/laopoxiao.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/fuhaojuji.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/zhijiang.gif',
      frame: 1,
      isGif: true,
    },
    { url: '/hotspots/system/map/realestate/po.gif', frame: 1, isGif: true },
    { url: '/hotspots/system/map/realestate/huo.gif', frame: 1, isGif: true },
    {
      url: '/hotspots/system/map/realestate/chenshihouhuayuan.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/chonya.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/bupeng.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/jinshen.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/weipan.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/jijiangkaipan.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/jiazhiwadi.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/goudoubuli.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/wannianbuzhang.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/pingzhizhuzhai.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/coomming.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/xiaoguan.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/map/realestate/remaizhong.gif',
      frame: 1,
      isGif: true,
    },
  ],
};

const hotspotIconList: Group = {
  name: '热点图标',
  list: cbIconList
    .reduce((acc: LibItemSysIcon[], group: Group) => acc.concat(group.list), [])
    .filter((x) => x.frame === 1),
};

export const markerImageList: Group[] = [
  imageList,
  hotspotIconList,
  { ...cLayerIconAll, name: '图层图标' },
];
